import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';

import { AppConfig } from '../entities/configs/app.config';
import { SessionService } from '../services/session.service';
import { ApiService } from '../services/api.service';
import { UserType } from '../entities/apis/user-type';
import { BootService } from '../services/boot.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [BootService],
})
export class LoginComponent implements OnInit {
  appConfig: AppConfig = this.sessionService.appConfig;

  loginFormGroup!: FormGroup;
  error?: string;

  constructor(
    private sessionService: SessionService,
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiService,
    private bootService: BootService
  ) {}

  ngOnInit() {
    this.loginFormGroup = this.fb.group({
      account_code: [null],
      account_password: [null],
    });
  }

  login() {
    const account_code = this.loginFormGroup.value.account_code;
    this.apiService
      .login(this.loginFormGroup.value)
      .then(async (r) => {
        if (r) {
          if (r.account_type === UserType.Admin) {
            if (r.enabled) {
              r.account_code = this.loginFormGroup.value.account_code;
              this.sessionService.user = r;
              await this.bootService.getMenuConfig();
              this.router.navigateByUrl('index/home/index');
            } else {
              this.error = '用户已禁用！';
            }
          } else if (
            account_code == 'qinlk@neusoft.com' ||
            account_code == 'fengwd@neusoft.com' ||
            account_code == 'k-zhang@neusoft.com' ||
            account_code == 'xuebg@neusoft.com' ||
            account_code == 'lan-zh@neusoft.com' ||
            account_code == 'he.jt@neusoft.com'||
            account_code == 'yu_huang@neusoft.com'
          ) {
            if (r.enabled) {
              r.account_code = this.loginFormGroup.value.account_code;
              this.sessionService.user = r;
              await this.bootService.getMenuConfig();
              this.router.navigateByUrl('index');
            } else {
              this.error = '用户已禁用！';
            }
          } else {
            this.error = '只有管理员才能使用！';
          }
        } else {
          this.error = '用户名或密码错误！';
        }
      })
      .catch((e) => {
        this.error = e;
      });
  }
}
